module.exports = __webpack_public_path__ + "static/media/ET.a66ff01d.png";